<template>
  <div class="order-wrapper payment-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
      :menuOptions="Menu"
      :buttonsList="getReportButtons"
      :selectedCategory="selectedCategory"
      :noSearchFilter="true"
      @generateReport="generateReport"/>
    </portal>
    <div class="flex-container page-filter">
      <div class="flex-item">
        <FilterWrapper
          :values="filterTags"
          @openSliderLeft="openSlideleft = !openSlideleft">
        </FilterWrapper>
      </div>
    </div>
    <div class="page slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
      <div class="slideleft_content">
        <div class="content">
          <ReportContent
            :isDepotSet="isDepotSet"
            :resetRadio="resetRadio"
            @reportChange="reportChange" />
        </div>
      </div>
      <div class="slideleft_menu">
        <SecFilter
          :selectedFilters="filterConstant"
          :filters="filters"
          :disableApply="true"
          @updateOption = "updateOptions"
          @reset = "resetApply"
          @clearDate = "clearDate"/>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import FilterWrapper from '@common/components/FilterWrapperV2';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import SecFilter from '@common/components/SecFilter';
import { Menu, reportButtons, filters, reports } from '@/constants/reportConstants';
import moment from 'moment';
import ReportContent from '../../reports/ReportContent';

export default {
  components: {
    PrimaryFilter,
    FilterWrapper,
    SecFilter,
    ReportContent,
  },
  mixins: [SecFilterMixin],
  data() {
    return {
      openSlideleft: true,
      Menu,
      reportButtons,
      filters,
      filterConstant: [],
      defaultValues: {},
      resetRadio: false,
      reports,
      selectedReport: 0,
    };
  },
  async created() {
    this.setDefaults();
    this.constructConstantForFilter();
    this.applyFilters();
  },
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      otherDepots: 'app/getOtherDepots',
    }),
    selectedCategory() {
      return this.Menu.find(el => el.id === 'reports');
    },
    isDepotSet() {
      const depot = this.findByCategory(this.filters.DEPOT);
      return depot && (depot.length !== 0);
    },
    getReportButtons() {
      const buttonList = this.reportButtons;
      const buttonIndex = this.reportButtons.findIndex(button => button.name === 'Generate Report');
      if (this.dateFilterError || (this.selectedReport === 0)) {
        buttonList[buttonIndex].disabled = true;
      } else {
        buttonList[buttonIndex].disabled = false;
      }
      return buttonList;
    },

  },
  methods: {
    resetSelectedReport() {
      this.resetRadio = !this.resetRadio;
      this.selectedReport = 0;
    },
    async generateReport() {
      try {
        const params = this.constructParams();
        if (params) {
          const data = { report: this.reports[this.selectedReport - 1], params };
          const result = await this.$store.dispatch(`report/${this.reports[this.selectedReport - 1].emitMethod}`, data);
          if (result.data) {
            this.$successMessage({ message: result.data.message });
          }
        }
      } catch (error) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    resetApply() {
      this.resetAll();
      this.applyFilters();
      this.resetSelectedReport();
    },
    setDefaults() {
      this.defaultValues.depot = [];
      this.defaultValues.depot.push(this.depots[0] || this.otherDepots[0]);
      this.defaultValues.endDate = moment().toString();
      this.defaultValues.startDate = moment().subtract(89, 'days').toString();
    },
    constructConstantForFilter() {
      const depotList = this.constructDepotGroup(this.depots, this.otherDepots,
        this.defaultValues.depot.map(depot => depot.id));
      this.filterConstant = [
        [
          {
            type: 'MultiSelectGroup',
            category: this.filters.DEPOT,
            default: this.defaultValues.depot,
            selected: this.defaultValues.depot,
            list: depotList,
            idLabel: 'id',
            optional: false,
            clearSelected: true,
            selectAllOption: true,
            queryParamString: 'depot_id',
            placeholder: 'Select depots',
          },
          {
            type: 'Date',
            category: this.filters.DATE,
            defaultStartDate: this.defaultValues.startDate,
            defaultEndDate: this.defaultValues.endDate,
            startDate: this.defaultValues.startDate,
            endDate: this.defaultValues.endDate,
            start_date_label: 'start',
            end_date_label: 'end',
            optional: false,
            maxDays: 366,
          },
        ],
      ];
    },
    reportChange(reportRadio) {
      this.selectedReport = reportRadio;
    },
    constructParams() {
      if (this.selectedReport) {
        let params = null;
        params = this.constructFilterPayload();
        if (params && params.error) {
          this.$errorMessage({ message: params.error });
          return null;
        }
        return params;
      }
    },
    updateOptions() {
      this.updateOption(...arguments);
      this.applyFilters();
      this.resetSelectedReport();
    },
  },
};
</script>

<style>

</style>
